<div *ngIf="!router.url.endsWith('showtime')">
  <app-navbar></app-navbar>
  <app-loading [loading]="loading"></app-loading>
  <router-outlet *ngIf="!loading"></router-outlet>
  <app-footer></app-footer>
</div>
<div *ngIf="router.url.endsWith('showtime')">
  <router-outlet></router-outlet>
</div>
